import { normalizeFilingReport } from '../normalization';
import { AgrregatedDataType, SellerFilingReport } from '../types';
import { client } from './axiosClient';

export const generateConfirmationFileLink = async (
  file_id: number,
  company_id?: string
) => {
  const res = await client.post<string>(
    `/client/reports/confirmation/${file_id}/download`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const generatePaymentInstructionFileLink = async (
  payment_instruction_id: number,
  company_id?: string
) => {
  const res = await client.post<string>(
    `/client/reports/payment-instruction/${payment_instruction_id}/download`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postAgendaConfirm = async (
  report_id: number,
  company_id?: string
) => {
  const res = await client.post(
    `/client/reports/${report_id}/agenda-confirm`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postSubmitReport = async (
  reportId: number,
  company_id: string
) => {
  const res = await client.post(
    `/client/reports/${reportId}/submit`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getAggregatedDataOSSReport = async (
  report_id: number,
  company_id: string
) => {
  const res = await client.get<AgrregatedDataType[]>(
    `/client/reports/aggregated-info/${report_id}`,
    {
      params: {
        company_id,
      },
    }
  );

  return res.data;
};

export const getClientReports = async (company_id?: string) => {
  const res = await client.get<SellerFilingReport[]>('/client/reports', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getOngoingFiling = async (company_id?: string) => {
  const res = await client.get<SellerFilingReport[]>(
    '/client/reports/ongoing',
    {
      params: {
        company_id,
      },
    }
  );
  return res.data.map(normalizeFilingReport(false));
};

export const getCompletedFiling = async (company_id?: string) => {
  const res = await client.get<SellerFilingReport[]>(
    '/client/reports/completed',
    {
      params: {
        company_id,
      },
    }
  );
  return res.data.map(normalizeFilingReport(true));
};
